var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-ratings"},[_c('UserRatings',{attrs:{"profile-hash":_vm.hash}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }